import { combineReducers } from 'redux'
import remarkReducer from './remark';

const reportDetailReducer = combineReducers({
  remark: remarkReducer,
})

export default reportDetailReducer
